import { BudgetViewType } from "../types";

interface QuadrosSidebarProps {
  viewType: BudgetViewType;
  onViewTypeChange: (viewType: BudgetViewType) => void;
  isMobile: boolean;
  isTablet: boolean;
}

const QuadrosSidebar = ({ viewType, onViewTypeChange, isMobile, isTablet }: QuadrosSidebarProps) => {
  if (isMobile) {
    return (
      <div className="bg-[#ffff] rounded-lg p-3 mb-4">
        <div className="text-size-14 font-semibold text-gray-900 mb-2">Quadros</div>
        <div className="flex flex-row gap-2 overflow-x-auto">
          <div
            className={`px-3 py-2 rounded-md cursor-pointer text-size-12 whitespace-nowrap transition-colors duration-200 ${
              viewType === "geral"
                ? "bg-blue-100 border-l-4 border-blue-500 text-gray-900 font-medium"
                : "bg-white text-gray-600 border-l-2 border-transparent"
            }`}
            onClick={() => onViewTypeChange("geral")}
          >
            Geral
          </div>
          <div
            className={`px-3 py-2 rounded-md cursor-pointer text-size-12 whitespace-nowrap transition-colors duration-200 ${
              viewType === "cliente"
                ? "bg-blue-100 border-l-4 border-blue-500 text-gray-900 font-medium"
                : "bg-white text-gray-600 border-l-2 border-transparent"
            }`}
            onClick={() => onViewTypeChange("cliente")}
          >
            Cliente
          </div>
          <div
            className={`px-3 py-2 rounded-md cursor-pointer text-size-12 whitespace-nowrap transition-colors duration-200 ${
              viewType === "fabricante"
                ? "bg-blue-100 border-l-4 border-blue-500 text-gray-900 font-medium"
                : "bg-white text-gray-600 border-l-2 border-transparent"
            }`}
            onClick={() => onViewTypeChange("fabricante")}
          >
            Fabricante
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-[#ffff] rounded-lg p-4 ${isTablet ? "min-w-[120px]" : "min-w-[150px]"} flex flex-col`}>
      <div className="text-size-16 font-semibold text-gray-900 mb-3">Quadros</div>
      <div className="h-px bg-gray-300 mb-3"></div>
      <div className="flex flex-col gap-1">
        <div
          className={`px-4 py-2.5 rounded-md cursor-pointer text-size-14 transition-colors duration-200 ${
            viewType === "geral"
              ? "bg-blue-100 border-l-4 border-blue-500 text-gray-900 font-medium"
              : "bg-white text-gray-600 border-l-2 border-transparent hover:bg-gray-100"
          }`}
          onClick={() => onViewTypeChange("geral")}
        >
          Geral
        </div>
        <div
          className={`px-4 py-2.5 rounded-md cursor-pointer text-size-14 transition-colors duration-200 ${
            viewType === "cliente"
              ? "bg-blue-100 border-l-4 border-blue-500 text-gray-900 font-medium"
              : "bg-white text-gray-600 border-l-2 border-transparent hover:bg-gray-100"
          }`}
          onClick={() => onViewTypeChange("cliente")}
        >
          Cliente
        </div>
        <div
          className={`px-4 py-2.5 rounded-md cursor-pointer text-size-14 transition-colors duration-200 ${
            viewType === "fabricante"
              ? "bg-blue-100 border-l-4 border-blue-500 text-gray-900 font-medium"
              : "bg-white text-gray-600 border-l-2 border-transparent hover:bg-gray-100"
          }`}
          onClick={() => onViewTypeChange("fabricante")}
        >
          Fabricante
        </div>
      </div>
    </div>
  );
};

export default QuadrosSidebar;
